<template>
  <div class="template">
    <!-- <div style="width: 100%; display: flex; align-items: center">
      <el-input
        v-model="templateValue"
        placeholder="请输入备件名称"
        style="width: calc(100% - 60px)"
      ></el-input>
      <el-button style="width: 60px" type="primary" @click="openDialog"
        ><i class="el-icon-search"></i
      ></el-button>
    </div> -->
    <el-dialog
      title="选择系统价格表"
      top="5vh"
      :visible.sync="dialogVisible"
      width="70%"
      append-to-body
      :before-close="handleClose"
    >
      <div class="dialog-top">
        <el-input
          v-model="searchData.DeviceCode"
          clearable
          placeholder="请输入价格表名称"
          style="width: 250px; margin-left: 10px"
        ></el-input>

        <el-button
          type="primary"
          @click="handleSearch"
          style="margin-left: 10px"
          >查询</el-button
        >
      </div>
      <!-- @selection-change="handleSelect" -->
      <div class="dialog-center" v-loading="loading">
        <el-table
          :data="tableData"
          ref="dialogTable"
          style="width: 100%"
          height="calc(100% - 40px)"
          :class="type == 'checkBox' ? 'checkBoxTable' : 'radioTable'"
          @selection-change="handleSelectionChange"
          @select="handleSelect"
          @row-click="handleRowClick"
        >
          <el-table-column label="" width="50" type="selection">
          </el-table-column>
          <el-table-column label="序号" width="50" type="index">
          </el-table-column>
          <el-table-column label="价格表名称" align="center" prop="PriceName">
          </el-table-column>
          <el-table-column
            :label="priceType === '电' ? '是否峰谷价' : '是否阶梯价'"
            align="center"
            prop="IsLadderPrice"
            v-if="priceType != '油'"
          >
            <template slot-scope="scope">
              <el-tag v-if="scope.row.IsLadderPrice">是</el-tag>
              <el-tag type="success" v-else>否</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            label="按月/日计算"
            align="center"
            prop="DataType"
            v-if="priceType === '电'"
          >
            <template slot-scope="scope">
              <SelectDicName
                ref="SelectDicName"
                :typeValue="scope.row.DataType"
                code="DataType"
              ></SelectDicName>
            </template>
          </el-table-column>
          <el-table-column label="价格" align="center" prop="Price">
          </el-table-column>
          <el-table-column label="省份" align="center" prop="ProvinceName">
          </el-table-column>
          <el-table-column label="市/区" align="center" prop="CityName">
          </el-table-column>
          <el-table-column
            label="区/县/街道"
            align="center"
            prop="DistrictName"
          >
          </el-table-column>
          <el-table-column label="操作" align="center" prop="op">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click.stop="handleView(scope.row)"
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: right;
          "
        >
          <!-- <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pagination.PageIndex"
            :page-sizes="pagination.PageSizes"
            :page-size="pagination.PageRows"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pagination.total"
          >
          </el-pagination> -->
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" :loading="loading"
          >取 消</el-button
        >
        <el-button type="primary" @click="confirm" :loading="loading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <InfoDrawer ref="InfoDrawer"></InfoDrawer>
  </div>
</template>
<script>
import moment from 'moment'
import SelectDicName from '@/components/DicValue/SelectDicName.vue'
import InfoDrawer from './InfoDrawer.vue'
export default {
  data() {
    return {
      moment,
      dialogVisible: false,
      templateValue: '',
      searchData: {
        Province: '',
        City: '',
        District: '',
        State: '',
        Condition: 'Name',
        Keyword: '',
      },
      selectRows: [],
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      tableData: [],

      loading: false,
      selectedRows: [],
      ListUrl: '',
      InfoUrl: '',
      SubUrl: '',
      TitleData: [],
      drawer: false,
    }
  },
  components: { SelectDicName, InfoDrawer },
  props: {
    type: { default: 'checkBox', require: false, type: String },
    priceType: { default: '电', require: true, type: String },
  },
  methods: {
    handleView(row) {
      this.$refs.InfoDrawer.openForm(this.InfoUrl, '系统价格表详情', row, true)
    },
    getUrl() {
      if (this.priceType === '电') {
        this.ListUrl = '/Base/Base_ElectricityPrice/GetElectricityPriceList'
        this.InfoUrl = '/Base/Base_ElectricityPrice/GetElectricityPriceData'
        this.SubUrl = '/Base/Base_ElectricityPrice/SaveCopyData'
        this.TitleData = [
          { title: '价格表名称', dataIndex: 'PriceName', align: 'left' },
          { title: '是否阶梯价', dataIndex: 'IsLadderPrice', align: 'center' },
          { title: '按月/日计算', dataIndex: 'DataType', align: 'center' },
          { title: '价格', dataIndex: 'Price', align: 'right' },
          { title: '省份', dataIndex: 'ProvinceName', align: 'center' },
          { title: '市/区', dataIndex: 'CityName', align: 'center' },
          { title: '区/县/街道', dataIndex: 'DistrictName', align: 'center' },

          // { title: '创建时间', dataIndex: 'CreateTime', align: 'center', width: '8%', },
          // { title: '备注', dataIndex: 'Remark', align: 'center', width: '18%' },
        ][
          ({
            title: '价格表名称',
            dataIndex: 'PriceName',
            align: 'left',
            width: '15%',
          },
          {
            title: '是否阶梯价',
            dataIndex: 'IsLadderPrice',
            align: 'center',
            width: '8%',
            scopedSlots: { customRender: 'IsLadderPrice' },
          },
          { title: '价格', dataIndex: 'Price', align: 'right', width: '8%' },
          {
            title: '省份',
            dataIndex: 'ProvinceName',
            align: 'center',
            width: '14%',
          },
          {
            title: '市/区',
            dataIndex: 'CityName',
            align: 'center',
            width: '8%',
          },
          {
            title: '区/县/街道',
            dataIndex: 'DistrictName',
            align: 'center',
            width: '8%',
          },
          { title: '备注', dataIndex: 'Remark', align: 'center', width: '20%' },
          {
            title: '创建时间',
            dataIndex: 'CreateTime',
            align: 'center',
            width: '8%',
            scopedSlots: { customRender: 'CreateTime' },
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'left',
            scopedSlots: { customRender: 'action' },
          })
        ]
      } else if (this.priceType === '油') {
        this.ListUrl = '/Base/Base_OilPrice/GetOilPriceList'
        this.InfoUrl = '/Base/Base_OilPrice/GetOilPriceData'
        this.SubUrl = '/Base/Base_OilPrice/SaveCopyData'
      } else if (this.priceType === '气') {
        this.ListUrl = '/Base/Base_GasPrice/GetGasPriceList'
        this.InfoUrl = '/Base/Base_GasPrice/GetGasPriceData'
        this.SubUrl = '/Base/Base_GasPrice/SaveCopyData'
      } else if (this.priceType === '水') {
        this.ListUrl = '/Base/Base_WaterPrice/GetWaterPriceList'
        this.InfoUrl = '/Base/Base_WaterPrice/GetWaterPriceData'
        this.SubUrl = '/Base/Base_WaterPrice/SaveCopyData'
      } else {
        this.ListUrl = ''
        this.InfoUrl = ''
        this.SubUrl = ''
      }
    },
    confirm() {
      if (this.selectRows.length <= 0) {
        return this.$notify.warning('请选择')
      }
      this.$confirm('确认使用当前选中的价格表吗?', '提示', {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        this.loading = true
        try {
          let res = await this.$http.post(
            this.SubUrl + '?Id=' + this.selectRows[0]?.Id,
            {}
          )
          if (res.Success) {
            this.$notify.success('操作成功')
            this.loading = false
            this.$emit('success')
            this.dialogVisible = false
          } else {
            this.loading = false
            this.$notify.error(res.Msg)
          }
        } catch (error) {
          this.loading = false
        }
      })
    },
    handleRowClick(row, column, event) {
      if (this.type == 'checkBox') {
        this.$refs.dialogTable.toggleRowSelection(row)
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelect(selection, row) {
      console.log(selection, row)

      if (this.type == 'checkBox') {
        this.selectRows = selection
        return
      }
      this.$refs.dialogTable.clearSelection()
      this.$refs.dialogTable.toggleRowSelection(row)
      this.selectRows = [row]
    },
    handleSelectionChange(val) {
      console.log(val)
      if (this.type == 'checkBox') {
        this.selectRows = val
        return
      }
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post(this.ListUrl, {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {},
        })
        .then((resJson) => {
          this.loading = false
          this.tableData = resJson.Data
          this.pagination.total = resJson.Total
          this.$nextTick(() => {
            this.$refs.dialogTable.clearSelection()
          })
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    openDialog() {
      this.dialogVisible = true
      this.searchData.DeviceCode = ''
      this.searchData.device_name = ''
      this.searchData.purchase_date = ''
      this.getUrl()
      this.handleSearch()
    },
    handleClose() {
      this.dialogVisible = false
    },
  },
  mounted() {},
  created() {},
  computed: {},
  watch: {
    value(newValue) {
      this.templateValue = newValue
    },
  },
}
</script>
<style lang="scss" scoped>
.template {
  width: 100%;
}
::v-deep .el-dialog__body {
  padding: 20px;
  padding-top: 10px;
}
::v-deep .el-dialog__title {
  font-weight: bold;
}
.dialog-top {
  line-height: 30px;
}
.dialog-center {
  height: calc(70vh - 30px);
}
::v-deep
  .radioTable
  .el-table__header-wrapper
  .el-table-column--selection
  .cell {
  display: none;
}
</style>
